<div class="row p-4 text-center">
  <div class="col">
    <ng-template [ngIf]="tournamentBracketFormed" [ngIfElse]="noBracket">
      <h5>При удалении игрока сетка будет пересоздана</h5>
    </ng-template>
    <ng-template #noBracket>
      <h5>Игрок будет удалён из турнира</h5>
    </ng-template>
  </div>
  <div class="row">
    <div class="col pt-4">
      <div class="form-group">
        <button
          type="button"
          class="btn btn-danger"
          (click)="deletePlayer()"
        >
          Подтвердить
        </button>
      </div>
    </div>
    <div class="col pt-4">
      <button
        type="button"
        class="btn btn-light"
        (click)="closeModal()"
      >
        Отмена
      </button>
    </div>
  </div>
</div>
